import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { User, LanguageSelector } from 'components/shared';
import * as S from './styles';
import { usePermissions, useTranslation } from 'hooks';
import { translations } from './translations';

interface IModule {
  icon: any;
  name: string;
  description: string;
  active: boolean;
  innerUrl?: string;
  url?: string;
}

const hostname = window.location.hostname;

const getEnvironment = () => {
  if (hostname === 'localhost') {
    return 'http://localhost:3000/base/';
  }

  if (hostname === 'brenntag.webcol.systems') {
    return 'https://brenntag.webcol.systems/';
  }

  if (hostname === 'hml-brenntag.webcol.systems') {
    return 'https://hml-brenntag.webcol.systems/';
  }

  return 'https://brenntag.webcol.systems/';
};

const baseUrl = getEnvironment();

export const AsideMenu = () => {
  const history = useHistory();
  const { checkUserPermission } = usePermissions();
  const { getTranslation } = useTranslation(translations);
  const isHomolog = hostname === 'hml-brenntag.webcol.systems';
  const [controlTowerIsOpen, setControlTowerIsOpen] = useState(false);

  const modules: IModule[] = [
    {
      icon: <S.IconTracking />,
      name: getTranslation('Tracking'),
      description: getTranslation('descTracking'),
      active: checkUserPermission('accessTracking'),
      url: baseUrl + 'tracking',
    },
    {
      icon: <S.IconCheckFreight />,
      name: getTranslation('CheckFretes'),
      description: getTranslation('descCheckFretes'),
      active: false, //checkUserPermission('accessCheckFreights'),
      url: baseUrl + 'checkfrete',
    },
    {
      icon: <S.IconSettings />,
      name: getTranslation('configurador'),
      description: getTranslation('descConfigurador'),
      active: checkUserPermission('accessConfigurator'),
      innerUrl: '/settings',
    },
  ];

  const handleNavigation = useCallback(
    (module: IModule) => {
      if (module.active) {
        if (module.innerUrl) return history.push(module.innerUrl);
        if (module.url) return window.open(module.url);
      }
    },
    [history]
  );

  return (
    <S.Container testEnv={isHomolog}>
      <S.Content>
        <S.Logo onClick={() => history.push('/')} />
        <LanguageSelector />
        <User />
        <S.ButtonModule
          active={checkUserPermission('accessControlTower')}
          onClick={() => setControlTowerIsOpen(!controlTowerIsOpen)}
        // onClick={() => history.push('/control-tower/performance')}
        >
          <S.ModuleTitle isHomolog={isHomolog}>
            <S.IconControlTower />
            {getTranslation('controlTower')}
          </S.ModuleTitle>
          <S.ModuleDescription>
            {getTranslation('descControlTower')}
          </S.ModuleDescription>
          <S.SubMenuModule active={controlTowerIsOpen}>
            {/* <S.SubMenuModuleItem
              onClick={() => history.push('/control-tower/check-freights')}
            >
              {getTranslation('controlTowerSubmenu', 'checkFretes')}
            </S.SubMenuModuleItem>
            <S.SubMenuModuleItem
              onClick={() => history.push('/control-tower/distribution')}
            >
              {getTranslation('controlTowerSubmenu', 'distribuicao')}
            </S.SubMenuModuleItem> */}
            <S.SubMenuModuleItem
              onClick={() => history.push('/control-tower/performance')}
            >
              {getTranslation('controlTowerSubmenu', 'performance')}
            </S.SubMenuModuleItem>
            <S.SubMenuModuleItem
              onClick={() => history.push('/control-tower/billing')}
            >
              {getTranslation('controlTowerSubmenu', 'faturamento')}
            </S.SubMenuModuleItem>
            {/* <S.SubMenuModuleItem
              onClick={() => history.push('/control-tower/financial')}
            >
              {getTranslation('controlTowerSubmenu', 'financial')}
            </S.SubMenuModuleItem> */}
          </S.SubMenuModule>
        </S.ButtonModule>
        {modules.map((module) => (
          <S.ButtonModule
            active={module.active}
            onClick={() => handleNavigation(module)}
            key={module.innerUrl || module.url}
          >
            <S.ModuleTitle isHomolog={isHomolog}>
              {module.icon}
              {module.name}
            </S.ModuleTitle>
            <S.ModuleDescription>{module.description}</S.ModuleDescription>
          </S.ButtonModule>
        ))}
      </S.Content>
    </S.Container>
  );
};
